import { useCallback } from 'react';
import { Button, Typography } from '@mui/material';

import { useAssistant } from '@core/assistant/providers/Provider';
import { SCREENS } from '@core/assistant/interfaces';

import { useStyles } from './styles';

interface IQuestionBox {
  title: string;
}

const QuestionBox = ({ title }: IQuestionBox) => {
  const classes = useStyles();

  const { setOpen, setNavigationHistory, navigate, teleportToRegion } =
    useAssistant();

  const handleClick = useCallback(() => {
    teleportToRegion(title);
    setOpen(false);
    setNavigationHistory([]);
    navigate(SCREENS.DEFAULT);
  }, [title]);

  return (
    <Button onClick={handleClick} sx={classes.box}>
      <Typography sx={classes.title}>{title}</Typography>
    </Button>
  );
};

export default QuestionBox;
